import {Component} from '@angular/core';

@Component({
  selector: 'app-default',
  templateUrl: './default-overlay.component.html',
  styleUrls: ['./default-overlay.component.scss']
})
export class DefaultOverlayComponent { }
